module.exports = __webpack_public_path__ + "img/icon-side-bar-3.d45a940f.svg";